import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {forkJoin, from, Observable, of, Subscription} from 'rxjs';
import {AppConfigService} from "../services";
import {Store} from "@ngrx/store";
import {IDealCard} from "../modules/shared/models";
import {
  updateDeal,
  updateDealId,
  updateDealRole,
  updateDealTabs
} from "../modules/redux";
import {IBusinessUnitRole} from "../modules/business-units/models";
import {INavItem} from "../models";
import {Location} from "@angular/common";
import {DealService, DealTeamMembersService} from "../modules/deals/services";
import { DataService } from '../services/data/data.service';

@Injectable({
  providedIn: 'root'
})
export class DealGuard implements CanActivate {

  // private readonly LOGIN_PATH = '/auth/login';
  // config$: Subscription = new Subscription();
  // config: Config = initialConfigState;
  dealId: string = '';

  constructor(
    private router: Router,
    private dealService: DealService,
    private dataService: DataService,
    private dealTeamMemberService: DealTeamMembersService,
    private appConfig: AppConfigService,
    private store: Store) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> | Observable<boolean | UrlTree> {
    var dealId = route.paramMap.get('id');
    console.log("Running deal guard for Id", dealId);

    // if no dealId then go to error
    if (!dealId) {
      return of(this.router.createUrlTree(['/error']));
    }

    this.dealId = dealId;
    this.store.dispatch(updateDealId({dealId: dealId}));
    this.dataService.selectedDealId = dealId;

    return new Promise<boolean | UrlTree> ((resolve) => {

      forkJoin([
        this.dealService.getDeal(this.dealId),
        this.dealTeamMemberService.getDealTeamMemberPermissions(this.dealId),
        this.appConfig.getDealTabsByDealId(this.dealId)
      ])
      .subscribe({
        next: ([dealCardResult, dealPermissionsResult, dealNavResult]) => {
          // console.log("=============> ", dealCardResult, dealPermissionsResult, dealNavResult);

          // deal card data
          var dealCard = dealCardResult as IDealCard;
          this.dataService.selectedDeal = dealCard;
          this.store.dispatch(updateDeal({deal: dealCard}));

          // deal permission role
          var dealPermissionRole = dealPermissionsResult as IBusinessUnitRole;
          this.store.dispatch(updateDealRole({dealRole: dealPermissionRole}));

          // set role and permissions
          this.dataService.setDealTeamPermissionsByRole(dealPermissionRole);

          // deal tabs (navigation)
          var dealTabs = dealNavResult as INavItem[];
          this.dataService.dealTabs = dealTabs;
          this.store.dispatch(updateDealTabs({tabs: dealTabs}));

          // Check see if the deal endpoint that is trying to be acessed 
          // get deal segment
          var dealSegments = state.url.split('?')[0].toString().split('/').filter(x => !!x);
          if (dealSegments.length >= 4)  {
            var dealSegment = dealSegments[3];
            var dealTab = dealTabs.filter(x => x.link.startsWith('/' + dealSegment) && x.enabled && x.hidden == false);

            // console.log("DEAL TAB", dealSegment, dealTab);
            if (dealTab.length == 0) {
              // deal tab does not exist, 
              resolve(this.router.createUrlTree(['/', this.dataService.getBuSlug(), "deals"]))
            }
          }

          resolve(true);
        },
        error: (error) => {
          console.error("Error loading deal data", error);
          resolve(this.router.createUrlTree(['/error'], {queryParams: {message: "You do not have access to this deal or it does not exist."}}));
        }
      });
      
    //   .subscribe(([dealCardResult, dealPermissionsResult, dealNavResult]) => {

    //     // console.log("=============> ", dealCardResult, dealPermissionsResult, dealNavResult);

    //     // deal card data
    //     var dealCard = dealCardResult as IDealCard;
    //     this.dataService.selectedDeal = dealCard;
    //     this.store.dispatch(updateDeal({deal: dealCard}));

    //     // deal permission role
    //     var dealPermissionRole = dealPermissionsResult as IBusinessUnitRole;
    //     this.store.dispatch(updateDealRole({dealRole: dealPermissionRole}));

    //     // set role and permissions
    //     this.dataService.setDealTeamPermissionsByRole(dealPermissionRole);

    //     // deal tabs (navigation)
    //     var dealTabs = dealNavResult as INavItem[];
    //     this.dataService.dealTabs = dealTabs;
    //     this.store.dispatch(updateDealTabs({tabs: dealTabs}));

    //     // Check see if the deal endpoint that is trying to be acessed 
    //     // get deal segment
    //     var dealSegments = state.url.split('?')[0].toString().split('/').filter(x => !!x);
    //     if (dealSegments.length >= 4)  {
    //       var dealSegment = dealSegments[3];
    //       var dealTab = dealTabs.filter(x => x.link.startsWith('/' + dealSegment) && x.enabled && x.hidden == false);

    //       // console.log("DEAL TAB", dealSegment, dealTab);
    //       if (dealTab.length == 0) {
    //         // deal tab does not exist, 
    //         resolve(this.router.createUrlTree(['/', this.dataService.getBuSlug(), "deals"]))
    //       }
    //     }

    //     resolve(true);
    //   })
    });
  }
}
